'use strict';

import moment from 'moment';
import raven from 'raven';
import angular from 'angular';

import SimpleMessages from 'app/controllers/simple-messages';

import SendCollectionsTpl from './send-collections.html';
import SendCollectionsController from './send-collections.controller';

class CollectionsController {
    /* @ngInject */
    constructor(
        CollectionsService,
        EmployeesService,
        OrderTranslationService,
        StorageService,
        $scope,
        $q,
        $state,
        $mdToast,
        $mdDialog
    ) {
        this.user = $scope.$parent.$resolve.user;
        Object.assign(this, {
            CollectionsService,
            EmployeesService,
            OrderTranslationService,
            StorageService,
            $scope,
            $q,
            $state,
            $mdToast,
            $mdDialog
        });
        Object.assign(this, SimpleMessages);

        this.query = {
            include: ['employee'],
            where: {},
            limit: 10,
            page: 1,
            order: 'createdAt DESC'
        };

        this.getCollections();

        this.onPagination = () => {
            this.getCollections();
        };

        this.onReorder = () => {
            this.getCollections();
        };

        if (this.user.isAdmin && (!this.model || !this.model.id)) {
            this.canChangeEmployee = true;
        }

        this.updateCurrentEmployeeId();

        this.selectedCollections = {};
    }

    updateCurrentEmployeeId() {
        let employeeId = this.user.isAdmin ?
            (this.employee && this.employee.id) : this.user.employeeId;
        this.employeeId = employeeId;
    }

    getCollections() {
        let qOpts = JSON.parse(JSON.stringify(this.query));

        // take advantage of this event to update it
        this.updateCurrentEmployeeId();

        if (this.mdOrder) {
            qOpts.order = this.OrderTranslationService.translate(
                this.mdOrder
            );
        }

        if (this.id) {
            this.employee = null;
            this.from = null;
            this.to = null;
            qOpts.where = Object.assign(qOpts.where, {
                id: this.id
            });
        }

        if (!this.user.isAdmin) {
            qOpts.where = Object.assign(qOpts.where, {
                employeeId: this.user.employee.id
            });
        }
        if (this.employee) {
            qOpts.where = Object.assign(qOpts.where, {
                employeeId: this.employee.id
            });
        }
        if (this.onlyNonCollected) {
            if (!this.onlyApproved) {
                this.onlyApproved = true;
            }
            qOpts.where = Object.assign(qOpts.where, {
                collectedAt: null
            });
        }
        if (this.onlyApproved) {
            qOpts.where = Object.assign(qOpts.where, {
                state: 'approved'
            });
        }

        if (this.from) {
            qOpts.where = Object.assign(qOpts.where, {
                date: {
                    gte: this.from
                }
            });
        }
        if (this.to) {
            let dateTo = moment(this.to).endOf('day').toDate();
            if (this.from) {
                if (!qOpts.where.and) {
                    let and = [qOpts.where];
                    qOpts.where = {
                        and: and
                    };
                }
                qOpts.where.and.push({
                    date: {
                        lte: dateTo
                    }
                });
                qOpts.where.and.push({
                    date: {
                        gte: this.from
                    }
                });
            } else {
                qOpts.where = Object.assign(qOpts.where, {
                    date: {
                        lte: dateTo
                    }
                }); 
            }
        }

        let queryReady = this.CollectionsService
            .getModels(qOpts)
            .then(collections => {
                this.collections = collections;
            });
        let countReady = this.CollectionsService
            .getCount(qOpts)
            .then(result => {
                this.collectionsCount = result.count;
            });
        this.promise = this.$q.all([queryReady, countReady]);
        return this.promise;
    }

    querySearchEmployee() {
        return this.EmployeesService.find({
            filter: {
                where: {
                    name: {
                        ilike: `%${this.searchTextEmployee}%`
                    }
                }
            }
        });
    }

    newCollection() {
        this.showSpin = true;
        this.CollectionsService.getDraft({
            employeeId: this.employeeId
        }).then(result => {
            this.showSpin = false;
            console.debug(result);
            this.$state.go('editCollection', {
                id: result.collection.id
            });
        }, err => {
            raven.captureException(err);
            console.error(err);
            this.simpleError('Ha ocurrido un error');
        });
    }

    getStateLabel(collection) {
        if (collection.state == 'approved') {
            return 'APROBADA';
        } else if (collection.state == 'sent') {
            return 'ENVIADA';
        } else {
            return 'BORRADOR';
        }
    }

    onToggleCollection(collection) {
        let someSelected = Object.keys(this.selectedCollections)
            .map(id => this.selectedCollections[id])
            .filter(v => v)
            .length > 0;

        if (someSelected) {
            this.someCollectionsSelected = true;
        } else {
            this.someCollectionsSelected = false;
        }
    }

    sendCollections(ev) {
        let collections = this.collections.filter(
            c => this.selectedCollections[c.id]
        );
        let total = collections.reduce(
            (sum, c) => sum + c.metadata.netCash, 0
        );
        this.$mdDialog.show({
            controller: SendCollectionsController,
            template: SendCollectionsTpl,
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                collections: collections,
                total: total
            }
        }).then(data => {
            this.showSendCollectionsSpin = true;
            return this.CollectionsService.sendToMain({
                collectionIds: collections.map(c => c.id),
                amount: data.amount,
                comments: data.comments
            });
        }).then(() => {
            collections.forEach(c => {
                c.collectedAt = new Date;
                delete this.selectedCollections[c.id];
            });
            this.simpleSuccess();
            this.showSendCollectionsSpin = false;
        }, err => {
            this.showSendCollectionsSpin = false;
            raven.captureException(err);
            console.error(err);
            this.simpleError();
        });
    }
}

export default CollectionsController;
